import styles from './DayModal.module.scss';
import {
  Button,
  Content,
  Heading,
  Image,
  Link,
  Modal,
} from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@wienenergiegithub/modules-next/hooks';

const DayModal = ({
  details,
  modalImage,
  modalTitle,
  onModalClose,
  status,
  store,
  subtitle,
  trackInteraction,
  unavailableCtaText,
  url,
}) => {
  const { t: translation } = useTranslation('calendar');

  return (
    <Modal
      className={styles.modal}
      header={<h1 className={styles.modalTitle}>{modalTitle}</h1>}
      onClose={() => onModalClose('schliessen')}
      store={store}
      theme="blue"
    >
      {!!subtitle && (
        <Heading as="h2" className={styles.subtitle} size="h5">
          {subtitle}
        </Heading>
      )}
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <Content withParser>{details}</Content>
          <div className={styles.buttonContainer}>
            <Button
              className={styles.button}
              disabled={status !== 'active'}
              isElevated
              onClick={() => trackInteraction('teilnehmen')}
              render={status === 'active' ? <Link to={url} /> : undefined}
              theme="primary"
            >
              {status === 'active'
                ? translation('participate')
                : unavailableCtaText || translation('previousDays')}
            </Button>
            <Button
              className={styles.button}
              onClick={() => onModalClose('schliessen')}
              variant="outline"
            >
              {translation('close')}
            </Button>
          </div>
        </div>
        <Image className={styles.modalImage} src={modalImage} />
      </div>
    </Modal>
  );
};

DayModal.propTypes = {
  details: PropTypes.string,
  modalImage: PropTypes.string,
  modalTitle: PropTypes.string.isRequired,
  onModalClose: PropTypes.func.isRequired,
  status: PropTypes.oneOf(['upcoming', 'active', 'expired']).isRequired,
  /* eslint-disable react/forbid-prop-types */
  /** `useDialogStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
  subtitle: PropTypes.string,
  trackInteraction: PropTypes.func.isRequired,
  unavailableCtaText: PropTypes.string,
  url: PropTypes.string,
};

export default DayModal;
